<div class="agpr-mentionSearchResult">
    <div
        class="agpr-mentionSearchResult-topLockBar"
        role="group"
        [attr.aria-label]="'Monitoring.result.mentionSearchResult.controls' | localize"
        [agprLoading]="filtersLoading"
    >
        <ng-content select="[topMessage]"></ng-content>

        @if (header) {
            <h2 class="agpr-mentionSearchResult-header">
                {{ header | localize  }}
            </h2>
        }

        <div
            class="agpr-mentionSearchResult-toolbar agpr-mentionSearchResult-toolbar--top"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <h3 class="u-srOnly">{{ 'toolbar' | localize }}</h3>
            <!-- top row-->
            <div
                class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--noPadding agpr-mentionSearchResult-toolbarColumn--left
                agpr-mentionSearchResult-toolbarColumn--noBorder"
            >
                <agpr-date-query-popup
                    [id]="'mentionSearchResult'"
                    [header]="'Monitoring.dateQueryDialog.header'"
                    [(ngModel)]="startDateRange"
                    [options]="dateFilterOptions"
                    [dateTypeOptions]="dateTypeFilterOptions"
                    [searchRange]="(
                        (
                            currentRoute?.type !== routeTypeEnum.folder &&
                            currentRoute?.type !== routeTypeEnum.mentions &&
                            currentRoute?.type !== routeTypeEnum.allSavedCoverageAnalyticsSyndicates &&
                            currentRoute?.type !== routeTypeEnum.folderAnalyticsSyndicates
                        ) &&
                        !(
                            search &&
                            search.searchCriteria &&
                            search.searchCriteria.isAccountSearch
                        )
                    ) ? searchRange : null"
                    (ngModelChange)="dateRangeChanged($event)"
                >
                </agpr-date-query-popup>
            </div>
            <div class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--large">
                <agpr-filter-dropdown
                    [id]="'resultsFilters'"
                    class="agpr-mentionSearchResult-toolbar-dropdown"
                    [showQuickFilter]="true"
                    quickFilterPlaceholder="Monitoring.filtersLocalization.keywords.quickPlaceholder"
                    [ariaLabel]="'Monitoring.filtersLocalization.ariaLabel' | localize"
                    [ariaDescribedBy]="'resultsFilters.chips'"
                ></agpr-filter-dropdown>
                <div class="agpr-mentionSearchResult-toolbarItem">
                    <agpr-filter-chips
                        #filterChipsComponent
                        [id]="'resultsFilters.chips'"
                    ></agpr-filter-chips>
                    @if (filterChipsComponent.chips.length > 1) {
                        <agpr-button
                            [id]="'filterClear'"
                            class="agpr-mentionSearchResult-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            (click)="clearFilters(true)"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Monitoring.result.filters.clear"
                            tooltipPosition="top"
                        ></agpr-button>
                    }

                    @if (showFilterLock) {
                        <agpr-button
                            [id]="'filter.lock'"
                            [ngClass]="{
                                'agpr-mentionSearchResult-toolbarIcon--lock': filtersLocked,
                                'agpr-mentionSearchResult-toolbarIcon--unlock': !filtersLocked
                            }"
                            [style]="buttonTypes.icon"
                            (click)="toggleFilterLock()"
                            [icon]="filtersLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="filtersLocked ? 'Monitoring.result.filters.unlock' : 'Monitoring.result.filters.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    }
                </div>
            </div>
            <div class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--top">
                <agpr-mentions-sort-order
                    [isDisabled]="!mentions?.length"
                    [style]="agprComponentStyleEnum.default"
                ></agpr-mentions-sort-order>
            </div>
            <div class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--top agpr-mentionSearchResult-toolbarColumn--right">
                <agpr-icon-dropdown
                    [id]="'mentionSearchResult.mentionViewOptions'"
                    displayIcon="fa-regular fa-duotone fa-eye"
                    [options]="mentionViewOptions"
                    [keepSelectedValue]="false"
                    inputTooltip="Monitoring.result.mentionViewSettings"
                    [(ngModel)]="selectedMentionViewOption"
                    (ngModelChange)="selectMentionViewOption()"
                    ariaLabel="Monitoring.result.mentionViewOptions"
                ></agpr-icon-dropdown>
            </div>
        </div>
        <!-- middle row -->
        @if (hasMonitoringAccess) {
            <div
                class="agpr-mentionSearchResult-toolbar agpr-mentionSearchResult-toolbar--middle"
                [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
                (@toolbarCollapsed.start)="onAnimationStart($event)"
                (@toolbarCollapsed.done)="onAnimationDone($event)"
            >
                <div class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--right agpr-mentionSearchResult-toolbarColumn--large">
                    <agpr-dropdown
                        [id]="'mentionSearchResult.saveOptions'"
                        class="agpr-mentionSearchResult-toolbar-saveOptions"
                        [options]="saveOptions"
                        [(ngModel)]="selectedType"
                    ></agpr-dropdown>
                    @if (selectedType.value === saveOptionEnum.folder) {
                        <agpr-autocomplete
                            [id]="id + '.saveList'"
                            class="agpr-mentionSearchResult-toolbar-saveList"
                            labelField="name"
                            [ariaLabel]="'Monitoring.folderPicker.tooltip'"
                            placeholder="Monitoring.folderPicker.placeholder"
                            [(ngModel)]="selectedFolders"
                            [suggestions]="folderList$"
                            [customOptions]="folderAutocompleteOptions"
                            (itemSelected)="selectFolder($event)"
                            [dropdown]="true"
                            [showHiddenOption]="true"
                            [multiSelection]="true"
                        ></agpr-autocomplete>
                    }
                    @if (selectedType.value === saveOptionEnum.tag) {
                        <agpr-autocomplete
                            [id]="id + '.saveList'"
                            class="agpr-mentionSearchResult-toolbar-saveList"
                            labelField="name"
                            [ariaLabel]="'Monitoring.result.selectTags'"
                            placeholder="Monitoring.result.saveWithTags"
                            [(ngModel)]="selectedTags"
                            [suggestions]="tagList$"
                            [customOptions]="tagsAutocompleteOptions"
                            (itemSelected)="selectTag($event)"
                            [dropdown]="true"
                            [multiSelection]="true"
                        ></agpr-autocomplete>
                    }
                    <div class="agpr-mentionSearchResult-toolbarItem agpr-mentionSearchResult-tagsPicker">
                        <agpr-chip-container
                            #chipsComponent
                            [id]="'mentionSearchResult.saveSettings.chips'"
                            class="agpr-mentionSearchResult-toolbar-chipContainer"
                            [chips]="chips"
                            overflowMessage="Monitoring.result.saveSettings.chips.overflow"
                            (removeChip)="removeChip($event)"
                        ></agpr-chip-container>
                        <agpr-button
                            [id]="'mentionSearchResult.saveSelectedMentions'"
                            class="agpr-mentionSearchResult-toolbarIcon-save"
                            [label]="'Monitoring.result.saveMentions' | localize"
                            [style]="buttonTypes.tertiary"
                            [disabled]="!mentions?.length || selectedMentions.length < 1 || !!actionBeingPerformed"
                            (click)="saveSelectedMentions()"
                        >
                            @if (mode === modeEnum.topics && selectedMentions.length && !hasRemainingMentionSavingQuota) {
                                <span
                                    class="agpr-mentionSearchResult-toolbarIcon-saveIcon fa-solid fa-circle-minus"
                                    [pTooltip]="'Monitoring.result.saveSettings.limitExceeded' | localize"
                                    aria-hidden="true"
                                ></span>
                            }
                        </agpr-button>

                        @if (chips.length > 1) {
                            <agpr-button
                                [id]="'saveSettingsClear'"
                                class="agpr-mentionSearchResult-toolbarIcon-clear"
                                [style]="buttonTypes.icon"
                                (click)="clearSavedSettings()"
                                icon="fa-kit-duotone fa-agpr-remove-all"
                                tooltip="Monitoring.result.saveSettings.clear"
                                tooltipPosition="top"
                            ></agpr-button>
                        }

                        <agpr-button
                            [id]="'mentionSearchResult.saveSettings.lock'"
                            [ngClass]="{
                                'agpr-mentionSearchResult-toolbarIcon--lock': saveSettingsLocked,
                                'agpr-mentionSearchResult-toolbarIcon--unlock': !saveSettingsLocked
                            }"
                            [style]="buttonTypes.icon"
                            (click)="toggleSaveSettingsLock()"
                            [icon]="saveSettingsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="saveSettingsLocked ? 'Monitoring.result.saveSettings.unlock' : 'Monitoring.result.saveSettings.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    </div>
                </div>
            </div>
        }
        <!-- bottom row -->
        <div class="agpr-mentionSearchResult-toolbar agpr-mentionSearchResult-toolbar--bottom">
            <div class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--left">
                <span class="agpr-mentionSearchResult-selectToggle">
                    <agpr-checkbox
                        [id]="'mentionSearchResult_toggleSelectAll'"
                        [label]="(selectedMentions.length ?? 0).toString()"
                        [disabled]="!mentions?.length"
                        [binary]="true"
                        [pTooltip]="(selectedMentions.length === mentions.length ? 'Monitoring.result.selectNone' : 'Monitoring.result.selectAll') | localize"
                        tooltipPosition="top"
                        hiddenLabel="Monitoring.result.selectAll"
                        [ngModel]="mentions.length > 0 && selectedMentions.length === mentions.length"
                        (ngModelChange)="toggleSelectAll()"
                    ></agpr-checkbox>
                </span>
                <span class="agpr-mentionSearchResult-totalCount">
                    <span class="agpr-mentionSearchResult-totalCount">
                        {{ 'Paginator.of' | localize }}
                    </span>
                    <span class="agpr-mentionSearchResult-totalCountValue">
                        {{ mentionCount }}
                    </span>
                    @if (mentionCount > maxMentionCountLimit[currentRoute.type]) {
                        <span
                            role="img"
                            [id]="id + '.mentionCount'"
                            class="fa-regular fa-circle-info agpr-mentionSearchResult-toolbar--toolTipIcon"
                            agprTooltip="Monitoring.result.mentionCountExceededLimit"
                        ></span>
                    }

                    {{ (isSyndicateMode ? 'Monitor.syndicates.syndicatedGroups' : 'Monitoring.result.mentionCount') | localize }}
                </span>
            </div>
            <div class="agpr-mentionSearchResult-toolbarColumn agpr-mentionSearchResult-toolbarColumn--right">
                <agpr-paginator
                    [id]="'mentionSearchResult-paginator'"
                    [maxNumberOfItems]="maxMentionCountLimit[currentRoute.type]"
                    [isDisabled]="!mentions?.length"
                    [isSyndicateRoute]="isSyndicateRoute"
                ></agpr-paginator>
            </div>
        </div>
    </div>
    <div class="agpr-mentionSearchResult-filtersError">
        <ng-content select="[infoBanner]"></ng-content>
    </div>
    @if (isAccountSearch) {
        <agpr-message
            class="agpr-mentionSearchResult-filtersError"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Monitoring.result.savedCoverageSearch.infoBanner'| localize }}
            <agpr-button
                class="agpr-mentionSearchResult-infoBannerLink"
                [style]="buttonTypes.link"
                (click)="searchNewContent()"
            >
                {{ 'Monitoring.result.savedCoverageSearch.infoBanner.clickHere' | localize }}
            </agpr-button>
        </agpr-message>
    }

    @if (!mentions?.length && !isLoadingMentions && errorType === errorTypes.none && subscription) {
        <agpr-message
            class="agpr-mentionSearchResult-filtersError"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Monitoring.result.noMentionsFoundSubscription' | localize }}
        </agpr-message>
    }

    @if (!mentions?.length && !isLoadingMentions && errorType === errorTypes.none) {
        <agpr-message
            class="agpr-mentionSearchResult-filtersError agpr-mentionSearchResult-filtersError-noContent"
            [severity]="messageSeverityEnum.noContent"
        >
            {{ 'Monitoring.result.noMentionsFound' | localize }}
        </agpr-message>
    }

    @if (errorType === errorTypes.filters && filterError) {
        <div class="agpr-mentionSearchResult-filtersError">
            @if (filterError.filterTypes) {
                <agpr-message [severity]="messageSeverityEnum.warning">
                    {{ 'Monitoring.result.filterError' | localize }}
                    <ul class="agpr-mentionSearchResult-filtersErrorList">
                        <li
                            *ngFor="let filterType of filterError.filterTypes"
                        >
                            {{ 'Monitoring.filtersLocalization.' + filterType | localize }}

                            @if (filterError.localizedInvalidValueMap) {
                                : {{ filterError.localizedInvalidValueMap.get(filterType).join(', ') }}
                            }

                        </li>
                    </ul>
                </agpr-message>
            } @else {
                <agpr-message [severity]="messageSeverityEnum.warning">
                    {{ 'Monitoring.result.filterError.generic' | localize }}
                </agpr-message>
            }
        </div>
    }

    @if (errorType === errorTypes.queryLength) {
        <div class="agpr-mentionSearchResult-filtersError">
            <agpr-message [severity]="messageSeverityEnum.warning">
                {{ 'Monitoring.result.error.queryLength' | localize }}
            </agpr-message>
        </div>
    }

    @if (errorType === errorTypes.unknown) {
        <div class="agpr-mentionSearchResult-filtersError">
            <agpr-message [severity]="messageSeverityEnum.warning">
                {{ 'Monitoring.result.error.unknown' | localize }}
            </agpr-message>
        </div>
    }

    @if (errorType === errorTypes.apiLimit) {
        <div class="agpr-mentionSearchResult-filtersError">
            <agpr-message [severity]="messageSeverityEnum.warning">
                {{ 'Monitoring.result.error.apiLimit' | localize }}
            </agpr-message>
        </div>
    }

    @if (errorType === errorTypes.discoverListNotExist) {
        <div class="agpr-mentionSearchResult-discoverListError">
            <agpr-message [severity]="messageSeverityEnum.warning">
                <p class="infoLink">
                    {{ 'Monitoring.result.error.discoverListNotExist' | localize }}
                    {{ 'Monitoring.result.error.discoverListNotExist.helpLinkText1' | localize }}
                    <agpr-button
                        class="agpr-mentionSearchResult-discoverListError-link"
                        [style]="buttonTypes.link"
                        label="Monitoring.result.error.discoverListNotExist.helpLinkText2"
                        (click)="currentRoute.type === routeTypeEnum.results ? updateSearch() : updateSavedSearch()"
                    ></agpr-button>
                    {{ 'Monitoring.result.error.discoverListNotExist.helpLinkText3' | localize }}
                </p>
            </agpr-message>
        </div>
    }

    @if (hasInvalidDateRange) {
        <div class="agpr-mentionSearchResult-filtersError">
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ 'Monitoring.result.error.invalidDateRange' | localize: { startDate: validDateRangeStartDisplayString, endDate: validDateRangeEndDisplayString } }}
            </agpr-message>
        </div>
    }


    <div
        [agprLoading]="isLoadingMentions"
        class="agpr-mentionSearchResult-mentions"
    >
        <agpr-scroll-panel
            #scrollPanel
            (scrolledTopChange)="onScroll($event)"
        >
            <div class="agpr-mentionSearchResult-mentionsList">
                <h3 class="u-srOnly">{{ 'results' | localize }}</h3>
                <agpr-mention-list
                    [id]="'mentionList'"
                    [mentions]="mentions"
                    [mentionSearch]="search"
                    [showTranslate]="true"
                    [reGetCardHeight]="reGetCardHeight"
                    [groupDuplicates]="groupDuplicates"
                    [highlightKeywords]="highlightKeywords"
                    [badges]="(
                        currentRoute.type === routeTypeEnum.folder ||
                        currentRoute.type === routeTypeEnum.mentions ||
                        currentRoute.type === routeTypeEnum.folderAnalyticsSyndicates ||
                        currentRoute.type === routeTypeEnum.allSavedCoverageAnalyticsSyndicates) &&
                        !forceSyndicateSave
                        ? mentionAccountBadges : mentionMercuryBadges"
                    [showAllImages]="showImages"
                    [showMentionIndex]="showMentionIndex"
                    [compact]="searchResultsService.mentionsCompact"
                    [(ngModel)]="selectedMentions"
                    [(focusedMention)]="focusedMention"
                    (focusedMentionChange)="setFocusedMention($event)"
                    (mentionCardClicked)="mentionCardClicked.emit($event)"
                    (outletClicked)="outletClicked.emit($event)"
                    (contactClicked)="contactClicked.emit($event)"
                    (unlockMentionClicked)="unlockMention($event)"
                    (viewAllSyndicatesClicked)="viewAllSyndicatesClicked.emit($event)"
                    (selectedMentionClicked)="selectedMentionsChange.emit(this.selectedMentions)"
                    [highlightSavedMentions]="showSavedFlag && highlightSavedMentions"
                    [mentionContent]="mentionContent"
                    [selectedFolder]="dropdownFolder"
                    [savingLimitExceeded]="mode === modeEnum.topics && !hasRemainingMentionSavingQuota"
                    (openSavingLimitExceededDialog)="openMentionSavingLimitExceededDialog()"
                    [showMentionViewIcon]="showMentionViewIcon"
                    [useMentionCardErrorTemplate]="true"
                    [topLabelMention]="topLabelMention"
                    [topLabel]="topLabel"
                    [isSyndicateMode]="isSyndicateMode"
                ></agpr-mention-list>
            </div>
        </agpr-scroll-panel>
    </div>

    @if (showActionBar) {
        <agpr-action-bar [headingContext]="'results' | localize">
            <ng-template #left>
                @if (currentRoute.type === routeTypeEnum.results || currentRoute.type === routeTypeEnum.adHocAnalyticsSyndicates) {
                    <agpr-button
                        label="Monitoring.result.editSearchButtonLabel"
                        [id]="'mentionSearchResult.editSearchButton'"
                        [style]="buttonTypes.secondary"
                        (click)="updateSearch()"
                    ></agpr-button>
                }

                @if (currentRoute.type === routeTypeEnum.topic || currentRoute.type === routeTypeEnum.topicAnalyticsSyndicates) {
                    <agpr-button
                        [id]="'mentionSearchResult.refreshButton'"
                        label="Monitoring.result.refresh"
                        [loading]="refreshing"
                        [style]="buttonTypes.secondary"
                        (click)="refresh()"
                    ></agpr-button>
                }

                @if (selectedMentions.length > 0 &&
                    (currentRoute.type === routeTypeEnum.folder || currentRoute.type === routeTypeEnum.folderAnalyticsSyndicates)
                ) {
                    <agpr-button
                        label="Monitoring.result.removeFromFolderButtonLabel"
                        id="mentionSearchResult.removeFromFolderButton"
                        [style]="buttonTypes.secondary"
                        (click)="removeMentionsFromFolder()"
                    ></agpr-button>
                }

                @if (
                    selectedMentions.length > 0 &&
                    ( currentRoute.type === routeTypeEnum.folder ||
                    currentRoute.type === routeTypeEnum.mentions ||
                    currentRoute.type === routeTypeEnum.folderAnalyticsSyndicates ||
                    currentRoute.type === routeTypeEnum.allSavedCoverageAnalyticsSyndicates
                    )
                ) {
                    <agpr-button
                        [id]="'mentionSearchResult.deleteMentionsFromAccountButton'"
                        label="Monitoring.result.deleteMentionsFromAccountButtonLabel"
                        [style]="buttonTypes.secondary"
                        (click)="openDeleteMentionsDialog()"
                    ></agpr-button>
                }

                @if ((currentRoute.type === routeTypeEnum.subscriptionResults || currentRoute.type === routeTypeEnum.subscriptionAnalyticsSyndicates) && subscription) {
                    <agpr-button
                        [id]="'mentionSearchResult.updateSubscription'"
                        label="Monitoring.result.updateSubscription"
                        [style]="buttonTypes.secondary"
                        (click)="gotoUpdateSubscription()"
                    ></agpr-button>
                }
            </ng-template>

            <ng-template #right>
                <!-- Adds or edits the live agent watching this source -->
                @if (hasAgenticFeature && (
                    currentRoute.type === routeTypeEnum.topic ||
                    currentRoute.type === routeTypeEnum.topicAnalyticsSyndicates ||
                    currentRoute.type === routeTypeEnum.folder ||
                    currentRoute.type === routeTypeEnum.folderAnalyticsSyndicates ||
                    currentRoute.type === routeTypeEnum.subscriptionResults ||
                    currentRoute.type === routeTypeEnum.subscriptionAnalyticsSyndicates
                )) {
                    <agpr-button
                        label="Monitoring.result.agents"
                        [id]="'mentionSearchResult.agentsButton'"
                        icon="fa-kit-duotone fa-agpr-ai-generic"
                        [style]="buttonTypes.primary"
                        (click)="openAgents()"
                    ></agpr-button>
                }

                @if ((currentRoute.type === routeTypeEnum.topic) || (currentRoute.type === routeTypeEnum.topicAnalyticsSyndicates)) {
                    <agpr-button
                        label="Monitoring.result.editTopic"
                        [id]="'mentionSearchResult.EditTopicButton'"
                        [style]="buttonTypes.primaryB"
                        (click)="updateSavedSearch()"
                    ></agpr-button>
                }
                @if (currentRoute.type === routeTypeEnum.topic ||
                    currentRoute.type === routeTypeEnum.results ||
                    currentRoute.type === routeTypeEnum.adHocAnalyticsSyndicates ||
                    currentRoute.type === routeTypeEnum.topicAnalyticsSyndicates ||
                    ((currentRoute.type === routeTypeEnum.subscriptionResults || currentRoute.type === routeTypeEnum.subscriptionAnalyticsSyndicates) && subscription)
                ) {
                    <agpr-button
                        label="Monitoring.result.bulkActionButtonLabel"
                        [id]="'mentionSearchResult.bulkActionButton'"
                        [style]="buttonTypes.primaryB"
                        (click)="openBulkDialog()"
                    ></agpr-button>
                }
                @if (currentRoute.type === routeTypeEnum.folder ||
                    currentRoute.type === routeTypeEnum.mentions ||
                    currentRoute.type === routeTypeEnum.folderAnalyticsSyndicates ||
                    currentRoute.type === routeTypeEnum.allSavedCoverageAnalyticsSyndicates
                ) {
                    <agpr-split-button
                        class="agpr-mentionSearchResult-actions"
                        label="Actions"
                        panelPositionY="top"
                        panelPositionX="right"
                        [options]="actions"
                        [caretDown]="false"
                    ></agpr-split-button>
                }

                @if ((currentRoute.type === routeTypeEnum.results || currentRoute.type === routeTypeEnum.adHocAnalyticsSyndicates) && !isAccountSearch) {
                    <agpr-button
                        label="Monitoring.result.saveSearchAsTopic"
                        [id]="'mentionSearchResult.saveSearchAsTopic'"
                        [style]="buttonTypes.primary"
                        (click)="saveTopic()"
                    ></agpr-button>
                }

                @if ((currentRoute.type === routeTypeEnum.topic || currentRoute.type === routeTypeEnum.topicAnalyticsSyndicates) && topicDirty) {
                    <agpr-split-button
                        [id]="'mentionSearchResult.actions'"
                        label="Monitoring.save"
                        [style]="buttonTypes.primary"
                        [options]="saveActions"
                        [panelPositionY]="'top'"
                        [panelPositionX]="'right'"
                    ></agpr-split-button>
                }

                @if ((currentRoute.type === routeTypeEnum.subscriptionResults || currentRoute.type === routeTypeEnum.subscriptionAnalyticsSyndicates) && subscription) {
                    @if (subscription.status === mediaSubscriptionStatusEnum.PAUSED) {
                        <agpr-button
                            [id]="'mentionSearchResult.activateButton'"
                            label="activate"
                            [style]="buttonTypes.primary"
                            (click)="activate()"
                            [tooltip]="activateButtonTooltip | localize"
                            [disabled]="!enableActiveButton"
                        ></agpr-button>
                    } @else {
                        <agpr-button
                            [id]="'mentionSearchResult.pauseButton'"
                            label="pause"
                            [style]="buttonTypes.primary"
                            (click)="pause()"
                        ></agpr-button>
                    }
                }
            </ng-template>
        </agpr-action-bar>
    }
</div>
